module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-03.2adeffe3.jpg";